import { iconNames, Colors } from '@zapier/design-system';
export const iconConfig = {
    name: 'Icon',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/3a522cbdc17675325fdded0c9782a654.png',
    inputs: [
        {
            name: 'name',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
        },
        {
            name: 'color',
            type: 'string',
            enum: ['', ...Object.keys(Colors)],
        },
        {
            name: 'size',
            type: 'number',
        },
        {
            name: 'isBlock',
            type: 'boolean',
        },
        {
            name: 'ariaHidden',
            type: 'boolean',
        },
        {
            name: 'ariaLabel',
            type: 'string',
        },
        {
            name: 'canAcceptPointerEvents',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map